import type { RelatedPlace } from "~/lib/api";
import { cn } from "~/lib/utils";
import { ExpandableText } from "~/components/ui/expandable-text";
import { PlaceContactLinks } from "~/components/landing/PlaceContactLinks";
import { RelatedPlaces } from "~/components/landing/RelatedPlaces";

export interface PlaceOverviewProps {
  placeId: string;
  type: string;
  description: string | null;
  links: string[];
  email: string | null;
  phone: string | null;
  relatedPlaces?: RelatedPlace[];
  onSelectRelatedPlace?: (place: RelatedPlace) => void;
}

export function PlaceOverview({
  placeId,
  type,
  description,
  links,
  email,
  phone,
  relatedPlaces,
  onSelectRelatedPlace,
}: PlaceOverviewProps) {
  const hasContact = !!(email || phone || links?.length);

  return (
    <>
      {description && (
        <div className="p-4 bg-muted rounded-2xl">
          <ExpandableText lines={3}>
            <p className="text-sm text-secondary leading-relaxed italic whitespace-pre-line">
              &ldquo;{description}&rdquo;
            </p>
          </ExpandableText>
        </div>
      )}

      {hasContact && (
        <PlaceContactLinks
          links={links}
          email={email}
          phone={phone}
          placeId={placeId}
          context="landing_page"
          className={cn({ "mt-4": description })}
        />
      )}

      <RelatedPlaces
        type={type}
        relatedPlaces={relatedPlaces}
        onSelect={onSelectRelatedPlace}
        className={cn({ "mt-5 pt-5 border-t border-border": description || hasContact })}
      />
    </>
  );
}
